<template>
  <div>
    <slot :defer="defer" ></slot>
  </div>
</template>

<script>
import {mergeDeep} from "../../../../helper/objects";

/**
 * Component DeferredActions.vue
 *
 * @module DeferredActions
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/DeferredActions.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "DeferredActions",
  props: {
    actions: {
      type: Object,
      default: () => {
        return {
          confirm : {
            label : this.$t('confirm'),
            action : () => {}
          },
          cancel : {
            label : this.$t('buttons.cancel', {catalog: 'app_mobile'}),
            action : () => {}
          }
        }
      }
    },
    timeout : {
      type: [Number, null],
      default: () => 8000
    },
    message : {
      type: [String, null],
      default: () => null
    },
    openAction : {
      type: [String, Function, null],
      default: () => null,
    },
    timeoutAction : {
      type: [String, Function, null],
      default: () => null,
    },
    toastOptions : {
      type: [Object, null],
      default: () => null,
    }
  },
  methods: {
    runFunction(fn) {
      if (fn) {
        if (typeof fn === 'function') {
          fn()
        } else if (typeof fn === 'string') {
          fn = this.actions[fn]?.action;
          if (fn) {
            fn()
          }
        }
      }
    },
    defer() {
      const toastActions = [];

      for (let action in this.actions) {
        const actionConfig = this.actions[action];

        toastActions.push({
          text : actionConfig.label,
          onClick : (e, toastObject) => {
            if (this._timeout) {
              clearTimeout(this._timeout)
              this._timeout = null
            }
            toastObject.goAway(0);
            if (actionConfig.action) {
              actionConfig.action(e, toastObject)
            }
          }
        })
      }

      let toastOptions = {
        action: toastActions,
        position: 'bottom-center'
      };

      if (this.timeout) {
        toastOptions.duration = this.timeout;
      }

      if (this.timeout && this.timeoutAction) {
        if (this._timeout) {
          clearTimeout(this._timeout)
          this._timeout = null
        }
        this._timeout = setTimeout(() => {
          this.runFunction(this.timeoutAction)
        }, this.timeout);
      }

      if (this.toastOptions) {
        toastOptions = mergeDeep(toastOptions, this.toastOptions)
      }

      if (this.openAction) {
        this.runFunction(this.openAction)
      }

      this.$toasted.show(
          this.message ? this.message : this.$t('confirm'),
          toastOptions
      );
    }
  }
};
</script>
